<template>
  <el-row :gutter="10">
    <el-col :span="8">
      <el-image :src="bg" v-if="!isDemo" />
    </el-col>
    <el-col :span="16">
      <div style="margin: 0 20px; margin-top: 15px">
        <el-tabs v-model="activeTab">
          <el-tab-pane
            :label="$t('login.LOGIN.password')"
            name="username"
            style="padding-top: 40px"
          >
            <login-form-with-username></login-form-with-username>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('login.LOGIN.sms')"
            name="mobile"
            style="padding-top: 40px"
          >
            <login-form-with-mobile></login-form-with-mobile>
          </el-tab-pane>
          <el-tab-pane :label="$t('ImportMap')" name="social">
            <template #label>
              <el-row align="middle" :gutter="15">
                <el-col :span="8">
                  <el-link :href="wxSSO">
                    <el-image :src="wx" style="width: 14px; height: 14px" />
                    <el-text size="small">
                      {{ $t("login.LOGIN.wechat") }}
                    </el-text>
                  </el-link>
                </el-col>
                <el-col :span="8">
                  <el-link :href="qqSSO">
                    <el-image :src="qq" style="width: 14px; height: 14px" />

                    <el-text size="small">
                    {{ $t("login.LOGIN.qq") }}
                    </el-text>
                  </el-link>
                </el-col>
                <el-col :span="8">
                  <el-link :href="weiboSSO">
                    <el-image :src="weibo" style="width: 14px; height: 14px" />

                    <el-text size="small">
                    {{ $t("login.LOGIN.weibo") }}
                    </el-text>
                  </el-link>
                </el-col>
              </el-row>
            </template>
          </el-tab-pane>
        </el-tabs>
        <el-row>
          <el-col :span="4">
            <el-button link @click="openForgetPasswordDialog">{{
              $t("login.LOGIN.forget")
            }}</el-button>
          </el-col>
          <el-col :span="16"></el-col>
          <el-col :span="4">
            <el-button link @click="openRegisterDialog">{{
              $t("login.LOGIN.register")
            }}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
  <el-dialog
    style="padding: 20px; max-width: 700px"
    :title="$t('login.LOGIN.forget')"
    v-model="showForgetPasswordForm"
    destroy-on-close
    append-to-body
  >
    <forget-password-form @return_to_login="returnToLogin" />
  </el-dialog>
  <el-dialog
    style="padding: 20px; max-width: 700px"
    :title="$t('login.REGISTER.title')"
    v-model="showRegisterForm"
    destroy-on-close
    append-to-body
  >
    <register-form @return_to_login="returnToLogin"></register-form>
  </el-dialog>
</template>
<script>
import bg from "@/assets/login-bg.png";
import wx from "@/assets/wx.png";
import qq from "@/assets/qq.png";
import weibo from "@/assets/weibo.png";
import LoginFormWithUsername from "./LoginFormWithUsername";
import LoginFormWithMobile from "./LoginFormWithMobile";
import ForgetPasswordForm from "./ForgetPassword";
import RegisterForm from "./RegisterForm";
const MAPSCLOUD_SERVER = process.env.VUE_APP_SOCIAL_AUTH_SERVER;
const SSO_CALLBACK_URL = process.env.VUE_APP_SSO_CALLBACK_URL;
export default {
  components: {
    LoginFormWithUsername,
    LoginFormWithMobile,
    ForgetPasswordForm,
    RegisterForm,
  },
  data() {
    return {
      bg: bg,
      wx: wx,
      qq: qq,
      weibo: weibo,
      activeTab: "username",
      showForgetPasswordForm: false,
      showRegisterForm: false,
      isDemo: process.env.VUE_APP_IS_DEMO == 'true',
    };
  },
  computed: {
    wxSSO() {
      return `${MAPSCLOUD_SERVER}/oauth_client/weixin/login?next=${SSO_CALLBACK_URL}`;
    },
    qqSSO() {
      return `${MAPSCLOUD_SERVER}/oauth_client/qq/login?next=${SSO_CALLBACK_URL}`;
    },
    weiboSSO() {
      return `${MAPSCLOUD_SERVER}/oauth_client/weibo/login?next=${SSO_CALLBACK_URL}`;
    },
  },
  methods: {
    returnToLogin() {
      this.showForgetPasswordForm = false;
      this.showRegisterForm = false;
    },
    openForgetPasswordDialog() {
      this.showForgetPasswordForm = true;
    },
    openRegisterDialog() {
      this.showRegisterForm = true;
    },
  },
};
</script>
<style scoped></style>
